var CheckoutOwnerJs = (function ($) {
    var $radioButtons;
    var $clickElem;

    var hasContent = function(sel){
        return true && (sel) && $(sel).html().trim();
    };
    var initShowHideOwner = function (radioButtonsSel,ownerId) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideOwnerDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'),ownerId);
        $(radioBSel).on("click", function () {
            showHideOwnerDeliveryAddress($(this),ownerId);
        });
    };
    var showHideOwnerDeliveryAddress = function(target,ownerId) {
        if (target.attr("value") === ownerId) {
                $(".owner-delivery-details").show();
        }else{
             $(".owner-delivery-details").hide();
        }
    };
    return {
        initShowHideOwner: initShowHideOwner,
        showHideOwnerDeliveryAddress: showHideOwnerDeliveryAddress
    }
}) (jQuery);

$(document).ready(function() {
    var ownerId = $("#ownerRadioButton").val();
    if (typeof ownerId !== 'undefined') {
        CheckoutOwnerJs.initShowHideOwner(".j-delivery-method-radio-buttons",ownerId);
    }
});